let cookieUtil = {
  getCookie(cname){
    let name = cname + "=";
    let decodedCookie = decodeURIComponent(document.cookie);
    let ca = decodedCookie.split(';');
    for(let i = 0; i <ca.length; i++)
    {
      let c = ca[i];
      while (c.charAt(0) == ' ')
      {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  },
  setCookie(cname, cvalue, exdays){
    let expires = "";
    if (exdays && exdays > 0) {
      let d = new Date();
      d.setTime(d.getTime() + (exdays*24*60*60*1000));
      expires = "expires="+ d.toUTCString();
    }
    if (expires != ""){
      document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
    }else {
      document.cookie = cname + "=" + cvalue + ";path=/";
    }
  }
}

export default cookieUtil;



// WEBPACK FOOTER //
// ./src/assets/js/cookie-util.js